import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import TInputForm from "../../common/TInputForm";
import TSelectForm from "../../common/TSelectForm";

const AddLinkToPostWithSearchOptions = [
    { label: '발행일(0000/00/00) – [카테고리] - 제목', value: '3' },
    { label: '발행일(0000/00/00) – 제목', value: '1' },
    { label: '[카테고리] – 제목', value: '2' },
    { label: '제목', value: '4' },
]

class AddLinkToPostWithSearchForm extends Component {
    @autobind
    handleChange(item) {
        const { onChange } = this.props
        var newObject = Object();
        newObject['setup'] = item.value;
        onChange(
            Object.assign({},  this.props.data, {
                setting: Object.assign({},  this.props.data.setting, newObject),
                validated: true
            })
        )
    }

    render() {
        const { plugin, data } = this.props
        return (
            <div className="desc_plugin35">
                <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />
                <div className="info_plugin">
                    <div className="item_set item_sub">
                        이전 글은
                        <TSelectForm className="opt_set opt_plugin1" items={AddLinkToPostWithSearchOptions} selected={this.props.data.setting.setup} onSelect={this.handleChange} />
                        형태로 표시됩니다.
                    </div>
                </div>
                {this.props.saveButton()}
            </div>
        )
    }
}

AddLinkToPostWithSearchForm.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default AddLinkToPostWithSearchForm
